<template>
  <div id="app">
    <div class="margin">
      <AuthenticationForm></AuthenticationForm>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
// import { mapState,mapMutations } from 'vuex';
import AuthenticationForm from "./AuthenticationForm.vue";
import Footer from "../reuseable_components/Footer";

// const axios = require('axios');
export default {
  name: "LoginPage",
  components: {
    AuthenticationForm: AuthenticationForm,
    Footer: Footer,
  },
  data() {
    return {
      currentLocation: JSON.parse(localStorage.getItem("currentLocation")),
    };
  },
  mounted() {
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        if (ip) {
          if (
            !localStorage.getItem("currentIPAddress") ||
            localStorage.getItem("currentIPAddress") != ip
          ) {
            localStorage.setItem("currentIPAddress", ip);
            fetch(
              "?ip=" +
                ip +
                "&key=J4W6JFAMVC&package=WS25&addon=continent,country,region,city,geotargeting,country_groupings,time_zone_info"
            )
              .then((response) => response.json())
              .then((data) => {
                this.currentLocation = data;
                localStorage.setItem("currentLocation", JSON.stringify(data));
              });
          } else {
            this.currentLocation = JSON.parse(
              localStorage.getItem("currentLocation")
            );
          }
        }
      });
  },
};
</script>
<style  scoped>
.margin {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 1em;
  font-family: "Poppins", sans-serif;
}

</style>

